import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

import { NAVBAR_BREAKPOINTS } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/constants";

export const getHomeMenuPopoutContainerCss = (
  hasOpenSubMenu: boolean,
): CSSObject => ({
  display: "flex",
  flexDirection: "column",
  padding: "1rem 0",
  gap: "0.25rem",
  borderRadius: "0.5rem",
  background: constants.colors.ui.white[50],
  boxShadow: "0px 2px 6px 0px rgba(29, 29, 29, 0.16)",

  [`@media (max-width: ${NAVBAR_BREAKPOINTS.sm}px)`]: {
    borderRadius: "0 0 0.5rem 0.5rem",
    height: hasOpenSubMenu ? 0 : "auto",
    overflow: hasOpenSubMenu ? "hidden" : "auto",
  },
});

export const supportItemVisibilityBreakpointCss = {
  display: "inline-block",

  [`@media (min-width: ${NAVBAR_BREAKPOINTS.sm}px)`]: {
    display: "none",
  },
};

export const fullWidthButtonCss = {
  "button, a": {
    width: "100%",
  },
};
